import { Box, Button, Card, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  deleteUserAddress,
  getAdressOfUser,
} from "../../../../../testPrepDashboard/Api/DashboardApi";

import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import BlueMediumButton from "../../../../../../components/customButtons/BlueMediumButton";
import Loader from "../../../../../../../SAPPages/components/Loader/Loader";
import NoAddressScreen from "./NoAddressScreen";
import CustomPopup from "../../../../../../components/customPopup/CustomPopup";
import EditNewAddress from "./editNewAddressForm";
import DeleteConfirmationPopup from "../../../../../../components/customPopup/DeleteConfirmationPopup";
import ErrorPopupScreen from "../../../../../../components/customPopup/ErrorPopupScreen";
import { setDefaultAddressData } from "../../../../../../../redux/features/userAddress/addressDataSlice";
import AddNewAddressForm from "./AddNewAddressForm";

export default function ShowAllAddressList({
  handleClose,
  handleOpenSuccessPopup,
  setMessageTitle,
  setSubMessage,
  setRefreshPage,
}) {
  const userId = localStorage.getItem("userId");
  const dispatch = useDispatch();
  const [addressLoading, setAddressloading] = useState(true);
  const [userAddress, setUserAddress] = useState([]);
  const [defaultAddressSelected, setDefaultAddressSelected] = useState(null);
  const [OpenEditAddress, setOpenEditAddress] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonTitle, setButtonTitle] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [OpenAddAddressPopup, setOpenAddAddressPopup] = useState(false);
  const handlefetchAddress = async () => {
    setAddressloading(true);
    try {
      const response = await getAdressOfUser({
        user_id: parseInt(userId),
      });

      setUserAddress(response?.data);
      setAddressloading(false);
      const selectedAddress = response?.data?.find(
        (i) => i.is_default === true
      );

      // if (selectedAddress) {
      //   setDefaultAddressSelected(selectedAddress?.id); // Local state
      //   // dispatch(setDefaultAddressData(selectedAddress)); // Redux
      // }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddressloading(false);
      setUserAddress([]);
    }
  };

  useEffect(() => {
    handlefetchAddress(userId);
  }, [userId]);

  const handlesetDefaultAddress = (address) => {
    const selectedAddress = userAddress?.find((i) => i.id === address.id);

    if (selectedAddress) {
      setDefaultAddressSelected(selectedAddress); // Local state
    }
  };

  const handleOpenEditressPopup = (rowData) => {
    setOpenEditAddress(true);
    setSelectedData(rowData);
  };

  const handleCloseEditAddressPopup = () => {
    setOpenEditAddress(false);
  };

  const handleOpendeletePopup = (rowId) => {
    setOpenDeleteConfirmation(true);
    setSelectedRowId(rowId);
  };

  const handleClosedeletePopup = () => {
    setOpenDeleteConfirmation(false);
  };

  // Delete Address
  const handleCancelAddress = async () => {
    try {
      const response = await deleteUserAddress({
        user_id: parseInt(userId),
        id: selectedRowId,
      });

      if (response.statusCode === 200) {
        handleClosedeletePopup();
        // Update state: remove deleted address
        setUserAddress((prevAddresses) =>
          prevAddresses.filter((addr) => addr?.id !== selectedRowId)
        );
        handleOpenSuccessPopup();
        setMessageTitle("Address Deleted Successfully !!");
      } else if (response.statusCode === 400) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 404) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Got It");
      } else if (response.statusCode === 500) {
        setErrorMessage(response.message);
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      } else {
        setErrorMessage("Internal Server Error");
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      handleOpenErrorPopup();
      setButtonTitle("Try Again");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  const handleContinueWithAddress = () => {
    dispatch(setDefaultAddressData(defaultAddressSelected)); // Redux
    handleClose();
  };

  // open  add address popup
  const handleOpenAddAddressPopup = () => {
    setOpenAddAddressPopup(true);
  };

  // close add address popup

  const handleCloseAddAddressPopup = () => {
    setOpenAddAddressPopup(false);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            textAlign="start"
            color="#222222"
            fontFamily="Inter"
            fontSize="20px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 600 }}
          >
            {" "}
            Select Your Billing Address
          </Typography>

          <BlueMediumButton
            buttonTitle="Add New"
            onClick={handleOpenAddAddressPopup}
          />
        </Grid>

        {addressLoading ? (
          <Grid item xs={12}>
            <Loader text="Loading Address..." />{" "}
          </Grid>
        ) : !addressLoading && userAddress?.length === 0 ? (
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              <NoAddressScreen />
            </Box>
          </Grid>
        ) : (
          ""
        )}

        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            sx={{
              maxHeight: {
                xs: "400px", // mobile
                sm: "300px", // tablet
                md: "400px", // desktop
              },
              overflowY: "auto", // vertical scroll
              pr: 1, // optional: padding for scrollbar
              /* Hide scrollbar for all browsers */
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, Edge
              },
            }}
          >
            {userAddress?.length > 0 &&
              [...userAddress]
                .sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0))
                .map((address, index) => (
                  <Grid item xs={12}>
                    <Card
                      onClick={() => handlesetDefaultAddress(address)}
                      sx={{
                        border:
                          defaultAddressSelected?.id === address?.id
                            ? "2px solid #FFE2FA"
                            : "1.5px solid #EEEEEE",

                        
                        cursor: "pointer",
                        padding: "10px",
                        width: "100%",
                        borderRadius: "8px",
                     background:"#FFFDFF",
                        px: { xs: 1, sm: 2, md: 2 },
                        // Set dynamic height based on screen size
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            textAlign="start"
                            color="#572575"
                            fontFamily="Inter"
                            fontSize="16px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            fontStyle="normal"
                            style={{ fontWeight: 700 }}
                          >
                            {address?.is_default
                              ? "Default Address"
                              : `Address  ${index}`}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          sm={6}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                          gap={2}
                        >
                          <Box
                            width={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenEditressPopup(address);
                            }}
                          >
                            <Icon
                              icon="fe:edit"
                              color="#572575"
                              width={20}
                              height={18}
                            />
                          </Box>
                          {address?.is_default === true ? (
                            <Tooltip title="Please set a different address as the default before deleting this one">
                              <Box
                                width={24}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (address?.is_default === false) {
                                    handleOpendeletePopup(address?.id);
                                  }
                                }}
                                sx={{
                                  opacity:
                                    address?.is_default === true && "25%",
                                }}
                              >
                                <Icon
                                  icon="material-symbols:delete-outline-rounded"
                                  color="#F31919"
                                  width={20}
                                  height={18}
                                />
                              </Box>
                            </Tooltip>
                          ) : (
                            <Box
                              width={24}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpendeletePopup(address?.id);
                              }}
                            >
                              <Icon
                                icon="material-symbols:delete-outline-rounded"
                                color="#F31919"
                                width={20}
                                height={18}
                              />
                            </Box>
                          )}
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            {/* name */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Name :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.name}
                                </span>
                              </Typography>
                            </Grid>

                            {/* country */}

                            <Grid item xs={12} sm={6} md={3}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Country :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.country?.country_name}
                                </span>
                              </Typography>
                            </Grid>

                            {/* State */}

                            <Grid item xs={12} sm={6} md={6}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                State :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.state?.state_name}
                                </span>
                              </Typography>
                            </Grid>

                            {/* city */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                City :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.city?.city_name}
                                </span>
                              </Typography>
                            </Grid>

                            {/* zip code */}
                            <Grid item xs={12} sm={6} md={3}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="100%"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Zip Code :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.zip_code}
                                </span>
                              </Typography>
                            </Grid>

                            {/* address */}
                            <Grid item xs={12} sm={6} md={6}>
                              <Typography
                                color="#555555"
                                fontFamily="Inter"
                                fontSize="14px"
                                lineHeight="1.4"
                                letterSpacing="0px"
                                fontStyle="normal"
                                style={{ fontWeight: 400 }}
                              >
                                Street Address :{" "}
                                <span style={{ color: "#000000" }}>
                                  {address?.address}
                                </span>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                ))}
          </Grid>
        </Grid>

        {userAddress?.length > 0 && (
          <Grid item xs={12} container gap={2} justifyContent="center">
            <Button
              size="small"
              onClick={handleClose}
              sx={{
                color: "#555555",
                fontFamily: "Inter",
                fontWeight: 800,
                fontSize: "14px",
                border: "2px solid #EEEEEE",
                minWidth: "25%",
                height: 30,
              }}
            >
              Go Back
            </Button>
            <BlueMediumButton
              buttonTitle="Continue"
              minWidth="25%"
              onClick={handleContinueWithAddress}
            />
          </Grid>
        )}
      </Grid>

      <CustomPopup
        handleClose={handleCloseEditAddressPopup}
        component={
          <EditNewAddress
            handleClose={handleCloseEditAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setMessageTitle={setMessageTitle}
            setSubMessage={setSubMessage}
            selectedData={selectedData}
            setRefreshPage={setRefreshPage}
            setUserAddress={setUserAddress}
          />
        }
        open={OpenEditAddress}
        subtitle=""
        maxWidth="sm"
      />

      <DeleteConfirmationPopup
        open={openDeleteConfirmation}
        text="Delete Address Permanently ?"
        subtext="Oops! Are you sure you want to remove this address? You won’t be able to get it back."
        buttonTitle="Yes, Remove It"
        handleClose={handleClosedeletePopup}
        handleSubmit={handleCancelAddress}
      />

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        maxWidth="xs"
      />

      <CustomPopup
        handleClose={handleCloseAddAddressPopup}
        component={
          <AddNewAddressForm
            handleClose={handleCloseAddAddressPopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setSuccessTitle={setMessageTitle}
            setSubMessage={setSubMessage}
          />
        }
        open={OpenAddAddressPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
